import React from 'react';
import '../../../resources_membership_hotel/css/common/common.css';
import ScrollToTop from '../../atoms/scrollToTop';
import SubHeader1 from '../../../resources/image/subHeader1_3.png';
import { HeaderContainer } from '../../organisms/common/headerContainer';
import MembershipReservationPopupContainer from '../../organisms/common/membershipReservationPopupContainer';
import EstheticAndRestaurantCalendarContainer from '../../organisms/esthetic/estheticAndRestaurantCalendarContainer';
import EstheticInputUserContainer from '../../organisms/esthetic/estheticInputUserContainer';
import EstheticUserPopupContainer from '../../organisms/esthetic/estheticUserPopupContainer';
import { SubHeader } from '../../molecules/subHeader';
import EstheticCoursePopupContainer from '../../organisms/common/estheticCoursePopupContainer';


class EstheticReserveTemplate extends React.Component {

  render() {
    return (
      <>
        <ScrollToTop />
        <HeaderContainer
          Label categoryLabel1={"お客様情報入力"}
          categoryLabel2={"USER INPUT"}
          path={this.props.state.loginFlg ? "/reserve/top" : ""}
          bookedConfirmLabel={this.props.state.loginFlg ? "予約確認" : ""}
          importedFlg={true}
          onClickOpenReservationPopupWindow={this.props.state.loginFlg ? this.props.onClickOpenReservationPopupWindow : ""}
        />
        <SubHeader SubImage={SubHeader1} />
        <EstheticInputUserContainer
          state={this.props.state}
          setPopupData={this.props.setPopupData}
          setLoginFlg={this.props.setLoginFlg}
          setCalendarFlg={this.props.setCalendarFlg}
          onClickOpenCalendarWindow={this.props.onClickOpenCalendarWindow}
          onClickOpenPopupWindow={this.props.onClickOpenPopupWindow}
        />
        <EstheticUserPopupContainer
          state={this.props.state}
          setPopupData={this.props.setPopupData}
          setCalendarFlg={this.props.setCalendarFlg}
          onClickOpenCalendarWindow={this.props.onClickOpenCalendarWindow}
          onClickOpenPopupWindow={this.props.onClickOpenPopupWindow}
          onClickClosePopupWindow={this.props.onClickClosePopupWindow}
          onClickOpenCoursePopup={this.props.onClickOpenCoursePopup}
        />
        <EstheticCoursePopupContainer
          state={this.props.state}
          setPopupData={this.props.setPopupData}
          onClickCloseCoursePopup={this.props.onClickCloseCoursePopup}
          cornerBunKbn="2"
        />
        <MembershipReservationPopupContainer
          state={this.props.state}
          onClickClosePopupWindow={this.props.onClickCloseReservationConfPopupWindow}
        />
        <EstheticAndRestaurantCalendarContainer
          state={this.props.state}
          onClickOpenSelectDateWindow={this.props.onClickOpenSelectDateWindow}
          onClickOpenCalendarWindow={this.props.onClickOpenCalendarWindow}
          setCalendarFlg={this.props.setCalendarFlg}
          cornerBunKbn={"2"}
          onClickOpenPopupWindow={this.props.onClickOpenPopupWindow}
          onClickClosePopupWindow={this.props.onClickClosePopupWindow}
          setPopupData={this.props.setPopupData}
        />
      </>
    )
  }
}
export default EstheticReserveTemplate;